/* ============
 * Actions for the Management protocol template module
 * ============
 *
 * The actions that are available on the
 * Management protocol template module.
 */
import ManagementProtocolTemplateProxy from '@/proxies/ManagementProtocolTemplateProxy';
import types from './mutation-types';


export const getManagementProtocolTemplate = ({ commit }, id) => {
  commit(types.GET_MANAGEMENT_PROTOCOL_TEMPLATE);
  new ManagementProtocolTemplateProxy().getManagementProtocolTemplate(id)
    .then((response) => {
      commit(types.GET_MANAGEMENT_PROTOCOL_TEMPLATE_SUCCESS, response);
    }).catch((error) => {
      commit(types.GET_MANAGEMENT_PROTOCOL_TEMPLATE_FAIL, error);
    });
};

export const getProtocolList = ({commit, dispatch}, isGetProtocolTemplate) => {
  commit(types.GET_PROTOCOL_LIST);
  new ManagementProtocolTemplateProxy().getProtocolList().then((response) => {
    if (isGetProtocolTemplate) {
      dispatch('getManagementProtocolTemplate', response[0].id)
    }
    commit(types.GET_PROTOCOL_LIST_SUCCESS, response);
  }).catch((error) => {
    commit(types.GET_PROTOCOL_LIST_FAIL, error);
  });
}

export default {
  getManagementProtocolTemplate,
  getProtocolList
};
